"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.localize = localize;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));

var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");

/**
 * @description it translates 2 keys label ex: nameEn, nameAr
 */
function localize({
  source,
  key,
  language = _constants.LANGUAGE.EN
}) {
  return (0, _get2.default)(source, `${key}${(0, _capitalize2.default)(language)}`, '');
}